import { SalvosOrderSalesCommissionCalculationResult } from "src/api/generated/tenants/salvos/erp/sales/commission/model/salvosOrderSalesCommissionCalculationResult.ts";
import { formatIsoString } from "src/utils/dayjsUtils.ts";
import { formatMoneyWithCurrency } from "src/utils/numberUtils.ts";

const paymentMethodLabels: Record<
	SalvosOrderSalesCommissionCalculationResult["salespersonPaymentMethod"],
	string
> = {
	SALARY: "Palkka",
	INVOICE: "Lasku",
};

const secondInstallmentActionLabels: Record<
	SalvosOrderSalesCommissionCalculationResult["secondInstallmentAction"],
	string
> = {
	CREATED: "Luotu",
	UPDATED: "Päivitetty",
	DELETED: "Poistettu",
	UNCHANGED: "Ei muutoksia",
	NOT_NEEDED: "Ei tarvita",
};

const commissionCostLineActionLabels: Record<
	SalvosOrderSalesCommissionCalculationResult["commissionCostLineAction"],
	string
> = {
	CREATED: "Luotu",
	UPDATED: "Päivitetty",
	UNCHANGED: "Ei muutoksia",
};

export function formatSalvosOrderCommissionCalculationSummary(
	result: SalvosOrderSalesCommissionCalculationResult,
): string {
	const money = (amount: number) => formatMoneyWithCurrency(amount, result.currencyCode);
	const secondInstallment = result.secondInstallment
		? `2. erä: ${money(result.secondInstallment.amount)}, arvioitu hyväksyntä ${formatIsoString(
				result.secondInstallment.estimatedApprovalDate,
			)}`
		: "2. erää ei tarvita";

	return [
		`Tilaus: ${result.orderReference}`,
		`Myyjä: ${result.salespersonName}`,
		`Maksutapa: ${paymentMethodLabels[result.salespersonPaymentMethod]}`,
		`Kokonaisprovisio: ${money(result.totalCommission)}`,
		`1. erä: ${money(result.firstInstallment.amount)}, arvioitu hyväksyntä ${formatIsoString(
			result.firstInstallment.estimatedApprovalDate,
		)}`,
		secondInstallment,
		`2. erän käsittely: ${secondInstallmentActionLabels[result.secondInstallmentAction]}`,
		`Enintään 100 euron yhdistämissääntö: ${result.hundredEuroRuleApplied ? "Kyllä" : "Ei"}`,
		`Provisiokustannus: ${money(result.commissionCost)}`,
		`Kustannusrivin käsittely: ${commissionCostLineActionLabels[result.commissionCostLineAction]}`,
	].join("\n");
}
